module.exports = __webpack_public_path__ + "static/media/our_visions.03eea212.jpg";